<script setup>
import Button from "primevue/button";
import { getActiveLanguage } from 'laravel-vue-i18n';
</script>

<template>
    <div v-if="$page.props.user.subscription" class="divide-y dark:divide-neutral-700 min-w-full h-full">

        <!-- Aktivní od -->
        <div class="flex justify-between items-center pb-4">
            <div class="flex items-center gap-2">
                <i class="pi pi-calendar text-gray-500 dark:text-gray-300"></i>
                <span class="text-gray-700 dark:text-gray-300 font-medium">{{ $t('settings.sub_active_since_label') }}</span>
            </div>
            <span class="text-gray-800 dark:!text-white font-semibold">
                {{
                    Intl.DateTimeFormat(getActiveLanguage(), {
                        month: 'long',
                        year: 'numeric'
                    }).format(Date.parse($page.props.user.subscription.start_date))
                }}
            </span>
        </div>

        <!-- Plán -->
        <div class="flex justify-between items-center py-4">
            <div class="flex items-center gap-2">
                <i class="pi pi-star text-gray-500 dark:text-gray-300"></i>
                <span class="text-gray-700 dark:text-gray-300 font-medium">{{ $t('settings.sub_plan_label') }}</span>
            </div>
            <span class="text-gray-800 dark:!text-white font-semibold">
                {{ $page.props.user.subscription.plan_name }}
            </span>
        </div>

        <!-- Cena -->
        <div class="flex justify-between items-center py-4">
            <div class="flex items-center gap-2">
                <i class="pi pi-wallet text-gray-500 dark:text-gray-300"></i>
                <span class="text-gray-700 dark:text-gray-300 font-medium">{{ $t('settings.sub_price_label') }}</span>
            </div>
            <span class="text-gray-800 dark:!text-white font-semibold">
                {{
                    $page.props.user.subscription.plan_price > 0
                        ? $t('settings.sub_price_monthly', { amount: $page.props.user.subscription.plan_price })
                        : $t('settings.sub_free')
                }}
            </span>
        </div>

        <!-- Další platba -->
        <div class="flex justify-between items-center py-4" v-if="$page.props.user.subscription.plan_price > 0">
            <div class="flex items-center gap-2">
                <i class="pi pi-credit-card text-gray-500 dark:text-gray-300"></i>
                <span class="text-gray-700 dark:text-gray-300 font-medium">{{ $t('settings.sub_next_payment_label') }}</span>
            </div>
            <span class="text-gray-800 dark:!text-white font-semibold">
                {{
                    $page.props.user.subscription.expiration_date ? (
                    Intl.DateTimeFormat(getActiveLanguage(), {
                        month: 'long',
                        year: 'numeric',
                        day: 'numeric'
                    }).format(Date.parse($page.props.user.subscription.expiration_date))
                    ) : $t('settings.sub_plan_no_payment')
                }}
            </span>
        </div>

        <!-- Canceled -->
        <div class="flex justify-between items-center py-4" v-if="$page.props.user.subscription.canceled_at">
            <div class="flex items-center gap-2">
                <i class="pi pi-times text-gray-500 dark:text-gray-300"></i>
                <span class="text-gray-700 dark:text-gray-300 font-medium">{{ $t('settings.sub_canceled_by_user') }}</span>
            </div>
            <span class="text-gray-800 dark:!text-white font-semibold">
                {{
                    Intl.DateTimeFormat(getActiveLanguage(), {
                        month: 'long',
                        year: 'numeric',
                        day: 'numeric'
                    }).format(Date.parse($page.props.user.subscription.canceled_at))
                }}
            </span>
        </div>

        <!-- Klientské centrum -->
        <div class="flex justify-between items-center pt-4">
            <span class="text-gray-700 dark:text-gray-300 font-medium">{{ $t('settings.sub_manage_client_hint') }}</span>
            <a href="/subscriptions" target="_blank">
                <Button severity="contrast" :label="$t('settings.sub_go_btn')" class="px-6 py-2 text-sm rounded-full shadow">
                    <template #icon>
                        <div class="flex flex-col items-center">
                            <div class="flex flex-col items-center">
                                <div class="maeum-short"></div>
                                <div class="maeum-long"></div>
                                <div class="maeum-short"></div>
                            </div>
                        </div>
                    </template>
                </Button>
            </a>
        </div>
    </div>
    <div v-else class="p-6">
        {{ $t('settings.sub_unavailable') }}
    </div>
</template>

<style scoped lang="scss">
.bg-gradient-to-b {
    background: linear-gradient(to bottom, #f9fafb, #f3f4f6);
}

.text-gray-800 {
    color: #1f2937;
}

.text-gray-600 {
    color: #4b5563;
}

.text-gray-500 {
    color: #6b7280;
}

.shadow-sm {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.shadow-md {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.shadow-lg {
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}

.rounded-lg {
    border-radius: 0.75rem;
}

.rounded-xl {
    border-radius: 1rem;
}
</style>
